// extracted by mini-css-extract-plugin
export default {"wrapper":"Carousel_wrapper__KaYPg","leftNavigation":"Carousel_leftNavigation__418iJ","rightNavigation":"Carousel_rightNavigation__N8-So"};